module.exports = __webpack_public_path__ + "media/images/icons/footer-icon-youtube-hover-c90a4bffa0394797ae2c347fe6d817e0.png";